import { IconButton } from "@alchemy/ui";
import { ArrowLeft } from "@alchemy/ui/icons/24";
import { AlchemyMarkOnDark, AlchemyWhite } from "@alchemy/ui/icons/logos";
import classNames from "classnames";

import { ViewAsPreservingLink } from "../../common/ViewAsPreservingLink";

interface NavHeaderProps {
  onHideOverlay?: () => void;
  onLogoClick?: () => void;
  compact?: boolean;
}

const NavHeader = ({ onHideOverlay, onLogoClick, compact }: NavHeaderProps) => {
  return (
    <header
      className={classNames(
        "relative z-20 flex items-center gap-4 px-4 pb-2 pt-5 max-md:mt-0.5 md:px-5",
        onHideOverlay || !compact ? "" : "justify-center",
      )}
    >
      {onHideOverlay ? (
        <IconButton
          className="text-white"
          padding="lg"
          background="dark"
          onClick={onHideOverlay}
        >
          <ArrowLeft />
        </IconButton>
      ) : null}

      <IconButton
        background="dark"
        rounded="slight"
        as={ViewAsPreservingLink}
        to="/"
        onClick={onLogoClick}
        aria-label="Alchemy Logo"
      >
        {compact ? (
          <AlchemyMarkOnDark width={28} height={24} />
        ) : (
          <AlchemyWhite width={104} height={22} />
        )}
      </IconButton>
    </header>
  );
};

export default NavHeader;
